import styled from 'styled-components'

export const Title = styled.h2`
  font-size:26px;
  text-align:center;
`
export const Form = styled.div`
  display:flex;
  flex-direction:column;
  margin-top:25px;
`
